import React     from 'react';
import PropTypes from 'prop-types';
import Flux      from '../../../flux/Flux';

function withGalleryComments(T) {
	class GalleryComments extends React.Component {
		constructor(props) {
			super(props);

			this.state = {
				commentsTotalCount: 0,
				isCommented:        false,
			};

			this.onCommentsChange = this.onCommentsChange.bind(this);
		}

		componentDidMount() {
			Flux.Gallery.addCommentsChangeListener(this.onCommentsChange);

			this.onCommentsChange(this.props.album.id);
		}

		componentWillUnmount() {
			Flux.Gallery.removeCommentsChangeListener(this.onCommentsChange);
		}

		/**
		 * @param {number} albumId
		 */
		onCommentsChange(albumId) {
			if (this.props.album.id === albumId) {
				const data = Flux.Gallery.getCommentsData(this.props.album.id);

				if (!data) {
					return;
				}

				this.setState({
					commentsTotalCount: data.commentsTotal,
					isCommented:        !data.isGuestAllowedToCommentAlbum && (this.props.album.areCommentsVisible || this.props.album.isAllowedToCommentAlbum),
				});
			}
		}

		render() {
			return <T {...this.state} {...this.props} />;
		}
	}

	GalleryComments.propTypes = {
		album: PropTypes.shape({
			id:                      PropTypes.number,
			areCommentsVisible:      PropTypes.bool,
			isAllowedToCommentAlbum: PropTypes.bool,
		}),
	};

	return GalleryComments;
}

export default withGalleryComments;
